import {BaseContainerModel} from '../base-container.model';
import { app_tenant_deletion_event_hdr_RowClass } from '../../dbschema/app_tenant_deletion_event_hdr.model';

export class AppTenantDeletionEventHdrContainerModel extends BaseContainerModel {
  app_tenant_deletion_event_hdr: app_tenant_deletion_event_hdr_RowClass = new app_tenant_deletion_event_hdr_RowClass();
}